import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import GET_POST_SUMMARIZER_QUERY, {
  type GetPostSummarizerQuery,
} from '../../graphql/__generated__/GetPostSummarizerQuery.graphql';

interface Props {
  queryRef: PreloadedQuery<GetPostSummarizerQuery>;
}

export const useGetPostSummarizer = ({ queryRef }: Props) => {
  const data = usePreloadedQuery(GET_POST_SUMMARIZER_QUERY, queryRef);
  const result = data?.unified?.ai?.getPostSummarizer;

  if (result?.__typename === 'UnifiedAiPostSummarizerResult')
    return {
      result,
      summary: result.summary,
      keyPoints: result.keyPoints ?? [],
      sentiment: result.sentiment,
    };

  return {
    result: null,
    summary: null,
    keyPoints: null,
    sentiment: null,
  };
};

export default useGetPostSummarizer;
